// extracted by mini-css-extract-plugin
export default {"container":"RemoveUserCard_container__+JFk8","role":"RemoveUserCard_role__GVGC0","roles":"RemoveUserCard_roles__P-lXi"};